export let greenImageSize = 250;
export let failedImagesCounter = 0;
export let EzLocatorCourseId = null;
export let measureFromEnum = Object.freeze({
  frontClosest: "front-closest",
  closest: "closest",
  frontLeft: "front-left",
  center: "center",
});
export let rotationSetType = Object.freeze({
  Unknown: { value: 0, name: "Unknown" },
  Daily: { value: 1, name: "Daily" },
  Special: { value: 2, name: "Special" },
});
export let rotationType = Object.freeze({
  Regular: { value: 1, name: "Regular" },
  TodayOnly: { value: 2, name: "TodayOnly" },
});
export let usageType = Object.freeze({
  Unknown: { value: 0, name: "Unknown" },
  Regular: { value: 1, name: "Regular" },
  TodayOnly: { value: 2, name: "TodayOnly" },
});
export let daysOfWeek = Object.freeze({
  None: 0x00,
  Sunday: 0x01,
  Monday: 0x02,
  Tuesday: 0x04,
  Wednesday: 0x08,
  Thursday: 0x10,
  Friday: 0x20,
  Saturday: 0x40
});



